export const EVENT_SCHEDULE_CATEGORY_LIST: string[] = [
  'OT',
  '상담',
  '운동',
  '식사',
  '청소',
  '교육',
  '회의'
];
